import { FC } from 'react';
import { Input } from 'reactstrap';
import { useParsedSearchParams } from '../../../lib/util';
import { useQuery } from '@apollo/client';
import { GET_ALL_ASSETS } from '../../../graph-queries/tar/asset';

const AssetSelection: FC = () => {
  const [asset, setAsset] = useParsedSearchParams('asset');
  const { data } = useQuery(GET_ALL_ASSETS);
  const assets = data?.allAssets || [];

  return (
    <Input
      aria-label="asset-selection"
      name="asset"
      className="form-select-placeholder-hack"
      type="select"
      value={asset}
      required
      onChange={(e) => setAsset(e.target.value)}
      role="combobox"
    >
      <option disabled hidden value="" key="_placeholder_">
        Choose an asset
      </option>
      {assets.map((o) => (
        <option value={o?.assetName} key={o?.assetId}>
          {o?.displayName}
        </option>
      ))}
    </Input>
  );
};

export default AssetSelection;
